/**
 * @internal
 */
export const getWidestText = (
  textElement: HTMLElement,
  length: number,
  getValue: (index: number) => { primary: string; secondary: string; includeIcon?: boolean }
) => {
  const ctx = getContext();
  const width = { primary: 0, withSecondary: 0 };
  const iconWidth = 14;
  let value;

  if (ctx && textElement) {
    setFontStyle(ctx, textElement);

    for (let i = 0; i < length; i++) {
      value = getValue(i);

      width.primary = Math.max(
        width.primary,
        ctx.measureText(value.primary ?? '').width + (value.includeIcon ? iconWidth : 0)
      );
      width.withSecondary = Math.max(
        width.withSecondary,
        width.primary +
          ctx.measureText(value.secondary ? ` ${value.secondary}` : '').width +
          (value.includeIcon ? iconWidth : 0)
      );
    }
  }

  return width;
};

/**
 * @internal
 */
export const measureTextWidth = (textElement: HTMLElement, text: string) => {
  const ctx = getContext();

  if (ctx && textElement) {
    setFontStyle(ctx, textElement);
    return ctx.measureText(text ?? '').width;
  }

  return 0;
};

const getContext = () => document.createElement('canvas').getContext('2d');

const setFontStyle = (ctx: CanvasRenderingContext2D, textElement: HTMLElement) => {
  const style = window.getComputedStyle(textElement);
  // must be the following order of font-xxx
  const fontFamily = [
    style.getPropertyValue('font-style'),
    style.getPropertyValue('font-variant'),
    style.getPropertyValue('font-weight'),
    style.getPropertyValue('font-size'),
    style.getPropertyValue('font-family'),
  ];
  ctx.font = fontFamily.join(' ');
};

export const parseKey = (key: string) => {
  const k = key.replace(/(?!^-)^\D+/g, '');
  if (k === '') return -1;
  return parseInt(k);
};
